module.exports = __webpack_public_path__ + "static/datasheet-listen-ls-q3c-16eec0c62ba40e816150ef70c466ab1a.pdf";